import React, { useState } from 'react';
import { PasswordInput } from '../components/ui';
import { ShieldCheckIcon, UserIcon, LockClosedIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import styles from '../components/Login.module.css';

function SuperAdminLogin({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('/api/v1/superadmin/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await response.json();
      if (response.ok) {
        onLogin(data.access_token, data.user);
      } else {
        setError(data.error || 'Login failed');
      }
    } catch (err) {
      setError('Network error. Is the backend running?');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container} style={{ background: 'linear-gradient(135deg, #0F172A 0%, #1E1B4B 50%, #020617 100%)' }}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.iconWrap} style={{ background: '#4C1D95' }}>
            <ShieldCheckIcon className={styles.icon} />
          </div>
          <h1 className={styles.title}>Platform Admin</h1>
          <p className={styles.subtitle}>Super Admin Portal</p>
        </div>

        {error && <div className={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className={styles.field}>
            <label className={styles.label}>Username</label>
            <div className={styles.inputWrap}>
              <UserIcon className={styles.inputIcon} />
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                placeholder="Enter username"
                className={styles.input}
              />
            </div>
          </div>

          <div className={styles.field}>
            <label className={styles.label}>Password</label>
            <div className={styles.inputWrap}>
              <LockClosedIcon className={styles.inputIcon} />
              <PasswordInput
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter password"
                className={styles.input}
              />
            </div>
          </div>

          <button type="submit" className={styles.submitBtn} disabled={loading} style={{ background: '#4C1D95' }}>
            {loading ? (
              <>
                <span className={styles.spinner} />
                Signing in...
              </>
            ) : (
              <>
                <ArrowRightOnRectangleIcon style={{ width: 18, height: 18 }} />
                Sign In
              </>
            )}
          </button>
        </form>

        <p className={styles.footer}>Platform owners only — school staff should use the regular login.</p>
      </div>
    </div>
  );
}

export default SuperAdminLogin;
